function cartAnimation(add, position) {
  if (add) {
    // const element0 = document.querySelector(position ? position : '.giftsvg');
    // element0.style.display = 'block';
    // element0.classList.add('sendtocart');
    // element0.addEventListener('animationend', function () {
    //   element0.classList.remove('sendtocart');
    //   element0.style.display = 'none';
    // });
  }
  const element = document.querySelector('.myCartIcon');
  element.classList.add('animate__animated', 'animate__tada');
  element.addEventListener('animationend', function () {
    element.classList.remove('animate__animated', 'animate__tada');
  });
  const element1 = document.querySelector('.myCartCounter');
  element1.classList.add('animate__animated', 'animate__flipInY');
  element1.addEventListener('animationend', function () {
    element1.classList.remove('animate__animated', 'animate__flipInY');
  });
}

export { cartAnimation };
